// extracted by mini-css-extract-plugin
module.exports = {"root":"az_cI","--hover-effect":"az_dI","--width":"az_eI"};